import { importClass } from "../../utilities/dynamicImportsUtility";

export default class PricingStack extends HTMLElement {
  public constructor() {
    super();
  }

  public connectedCallback() {
    console.debug("Pricing Stack registered");
    if (document.readyState === "loading") {
      window.addEventListener("DOMContentLoaded", () => this.initialize());
    } else {
      this.initialize();
    }
  }

  private async initialize() {
    importClass(
      () =>
        import(
          /* webpackChunkName: "pricingStakController" */ "./pricingStackController"
        ),
      true,
      [this]
    );
  }
}

customElements.define("pricing-stack", PricingStack);
